<template>
  <div class="cp-frame" :class="star" :style="{height}">
    <slot></slot>
  </div>
</template>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .cp-frame
    width 7.02rem
    height auto;
    min-height 5.53rem
    background-image url("./images/d1.png"), url("./images/d2.png"), url("./images/d3.png");
    background-position: top left, center left, bottom left;
    background-size: 7.02rem 2.76rem, 7.02rem calc(100% - 5.52rem), 7.02rem 2.76rem;
    background-repeat: no-repeat, no-repeat, no-repeat;

</style>
<script>
import { isWeiXin, getParameterByName, isAndroid, setCookie, getCookie, deleteCookie, setCookieByDays } from "~/tools/utils";
export default {
  props: {
    height: {
      type: String,
      default: 'auto'
    }
  },
  data() {
    return {
      star: getParameterByName('star')
    }
  },
  mounted() {

  },
  methods: {
    handleClose(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('close')
      // store.commit(types.HIDE_MODAL);
    }
  }
}
</script>

